export default "__VITE_ASSET__B1uJYAxh__"